import React, { ReactNode } from 'react';
import { refreshLanguage } from 'shared/util/localization';
import localizationConstants from 'shared/util/translation/constants';
import Option from 'shared/components/form/option';

interface Props {
	className?: string;
	page?: string;
	children?: ReactNode;
}
const PhoenixLoginWrapper: React.FC<Props> = (props) => {
	const [lang, setLang] = React.useState(localStorage.getItem('lang') || 'de');
	return (
		<div className={`gray-bg phoenix-background-svg login-wrapper ${props.className || ''}`}>
			<div className='middle-box loginscreen animated fadeInDown'>
				<div>
					<div className='language-dropdown'>
						<select
							data-testid='language-dropdown'
							value={lang}
							className='form-control'
							onChange={(e) => {
								const language = e.target.value;
								refreshLanguage(language);
								setLang(language);
								// refresh to change language
								window.location.reload();
							}}
						>
							<Option name={localizationConstants.german} value='de' />
							<Option name={localizationConstants.english} value='en' />
						</select>
					</div>
					{props.children}
				</div>
			</div>
		</div>
	)
}

export default PhoenixLoginWrapper;
